import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import { a } from './_csAbt';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

export const N = (pz: ht.gridCz) => {

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.gridAbtz[_abtType] ? ica.gridAbtz[_abtType]() : ({} as ht.dz);

  const _oClds = [] as ht.ls;

  pz.lineCs?.filter(( _dz: ht.dz ) => hf.f(_dz)).map( ( _dz: ht.dz, _nLineIdx: ht.n ) => {

    const _lineAbtz = _abtz.lineCz ? _abtz.lineCz(_nLineIdx) : null;

    const _oLines = [] as ht.ls;
    _dz?.cellCs?.map( (_cellCz: ht.dz, _nCellIdx: ht.n) => {
      if (_cellCz) {
        _oLines.push(
          cr.c(BoxC.N, {
            key: `cell.${_nCellIdx}`,
            ... _cellCz,
            boxStlz: {
              ... _lineAbtz?.cellCz(_nCellIdx)?.boxStlz,
              ... _cellCz?.boxStlz,
            },
          })
        );
      }
    });
/*
hf.l(`GridC 38: ${hf.s({
          ... _lineAbtz?.boxStlz,
          ... _dz.boxStlz,
        })}`)
*/
    _oClds.push(
      cr.c(BoxC.N, {
        key: `row.${_nLineIdx}`,
        boxStlz: {
          ... _lineAbtz?.boxStlz,
          ... _dz.boxStlz,
        },
        oClds: _oLines
      })
    );

  })
  if (!hf.f(_oClds) && pz.msgCz) {
    _oClds.push(
      cr.c(TextC.N, {
        key: -10,
/*
        textz: {
          pfx: '該当なし',
          stlz: a('mb/1'),
        }
*/
        ... pz.msgCz,
      })
    )
  }

  return (
    cr.c(BoxC.N, {
      key: 'Tbl.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz
      },
      oClds: _oClds, 
    })
  )
};
